(function (factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js', './kotlinx-coroutines-core.js', './PaymentsKit-common.js', './kotlinx-serialization-kotlinx-serialization-core.js', './kotlinx-html.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'), require('./kotlinx-coroutines-core.js'), require('./PaymentsKit-common.js'), require('./kotlinx-serialization-kotlinx-serialization-core.js'), require('./kotlinx-html.js'));
  else {
    if (typeof globalThis['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'PaymentsKit-web'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'PaymentsKit-web'.");
    }
    if (typeof globalThis['kotlinx-coroutines-core'] === 'undefined') {
      throw new Error("Error loading module 'PaymentsKit-web'. Its dependency 'kotlinx-coroutines-core' was not found. Please, check whether 'kotlinx-coroutines-core' is loaded prior to 'PaymentsKit-web'.");
    }
    if (typeof globalThis['PaymentsKit-common'] === 'undefined') {
      throw new Error("Error loading module 'PaymentsKit-web'. Its dependency 'PaymentsKit-common' was not found. Please, check whether 'PaymentsKit-common' is loaded prior to 'PaymentsKit-web'.");
    }
    if (typeof globalThis['kotlinx-serialization-kotlinx-serialization-core'] === 'undefined') {
      throw new Error("Error loading module 'PaymentsKit-web'. Its dependency 'kotlinx-serialization-kotlinx-serialization-core' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-core' is loaded prior to 'PaymentsKit-web'.");
    }
    if (typeof globalThis['kotlinx-html'] === 'undefined') {
      throw new Error("Error loading module 'PaymentsKit-web'. Its dependency 'kotlinx-html' was not found. Please, check whether 'kotlinx-html' is loaded prior to 'PaymentsKit-web'.");
    }
    globalThis['PaymentsKit-web'] = factory(typeof globalThis['PaymentsKit-web'] === 'undefined' ? {} : globalThis['PaymentsKit-web'], globalThis['kotlin-kotlin-stdlib'], globalThis['kotlinx-coroutines-core'], globalThis['PaymentsKit-common'], globalThis['kotlinx-serialization-kotlinx-serialization-core'], globalThis['kotlinx-html']);
  }
}(function (_, kotlin_kotlin, kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core, kotlin_com_universaliun_payments_common, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core, kotlin_org_jetbrains_kotlinx_kotlinx_html) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var protoOf = kotlin_kotlin.$_$.ba;
  var getStringHashCode = kotlin_kotlin.$_$.c9;
  var initMetadataForClass = kotlin_kotlin.$_$.e9;
  var Unit_instance = kotlin_kotlin.$_$.p2;
  var THROW_CCE = kotlin_kotlin.$_$.tc;
  var CoroutineImpl = kotlin_kotlin.$_$.m7;
  var CoroutineScope = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.c;
  var isInterface = kotlin_kotlin.$_$.s9;
  var await_0 = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.a;
  var get_COROUTINE_SUSPENDED = kotlin_kotlin.$_$.x6;
  var initMetadataForLambda = kotlin_kotlin.$_$.i9;
  var VOID = kotlin_kotlin.$_$.b;
  var constructCallableReference = kotlin_kotlin.$_$.w8;
  var MainScope = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.d;
  var launch = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.e;
  var get_paymentsKitJson = kotlin_com_universaliun_payments_common.$_$.d;
  var PaymentsPublicConfigDto = kotlin_com_universaliun_payments_common.$_$.b;
  var getKClass = kotlin_kotlin.$_$.sa;
  var arrayOf = kotlin_kotlin.$_$.hd;
  var createKType = kotlin_kotlin.$_$.qa;
  var serializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.o2;
  var KSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.g2;
  var SetupIntentsResponseDto = kotlin_com_universaliun_payments_common.$_$.c;
  var initMetadataForCoroutine = kotlin_kotlin.$_$.g9;
  var Companion_instance = kotlin_kotlin.$_$.k2;
  var KtList = kotlin_kotlin.$_$.h4;
  var PaymentMethodDto = kotlin_com_universaliun_payments_common.$_$.a;
  var createInvariantKTypeProjection = kotlin_kotlin.$_$.pa;
  var _Result___init__impl__xyqfz8 = kotlin_kotlin.$_$.h;
  var createFailure = kotlin_kotlin.$_$.jd;
  var emptyList = kotlin_kotlin.$_$.e5;
  var _Result___get_isFailure__impl__jpiriv = kotlin_kotlin.$_$.j;
  var _Result___get_value__impl__bjfvqg = kotlin_kotlin.$_$.k;
  var until = kotlin_kotlin.$_$.oa;
  var Long = kotlin_kotlin.$_$.pc;
  var delay = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.b;
  var append = kotlin_org_jetbrains_kotlinx_kotlinx_html.$_$.k;
  var attributesMapOf = kotlin_org_jetbrains_kotlinx_kotlinx_html.$_$.p1;
  var P = kotlin_org_jetbrains_kotlinx_kotlinx_html.$_$.e1;
  var IllegalArgumentException_init_$Create$ = kotlin_kotlin.$_$.r3;
  var DIV = kotlin_org_jetbrains_kotlinx_kotlinx_html.$_$.s;
  var joinToString = kotlin_kotlin.$_$.o5;
  var SPAN = kotlin_org_jetbrains_kotlinx_kotlinx_html.$_$.g1;
  var enumEncode = kotlin_org_jetbrains_kotlinx_kotlinx_html.$_$.j;
  var attributesMapOf_0 = kotlin_org_jetbrains_kotlinx_kotlinx_html.$_$.o1;
  var BUTTON = kotlin_org_jetbrains_kotlinx_kotlinx_html.$_$.r;
  var ButtonType_button_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_html.$_$.a;
  var set_onClickFunction = kotlin_org_jetbrains_kotlinx_kotlinx_html.$_$.m;
  //endregion
  //region block: pre-declaration
  initMetadataForClass(AddCardLabels, 'AddCardLabels');
  initMetadataForLambda(AddCardFlow$mountStripeCardElement$lambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(AddCardFlow$mountPayPalButton$lambda$lambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($startCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($pollForNewPaymentMethodCOROUTINE$, CoroutineImpl);
  initMetadataForClass(AddCardFlow, 'AddCardFlow', VOID, VOID, VOID, [3, 0]);
  initMetadataForClass(PaymentMethodsClassNames, 'PaymentMethodsClassNames', PaymentMethodsClassNames);
  initMetadataForClass(PaymentMethodsLabels, 'PaymentMethodsLabels');
  //endregion
  function AddCardLabels(noProviderConfiguredError, stripeNotLoadedError, cardSaveError, genericErrorPrefix) {
    this.s20_1 = noProviderConfiguredError;
    this.t20_1 = stripeNotLoadedError;
    this.u20_1 = cardSaveError;
    this.v20_1 = genericErrorPrefix;
  }
  protoOf(AddCardLabels).toString = function () {
    return 'AddCardLabels(noProviderConfiguredError=' + this.s20_1 + ', stripeNotLoadedError=' + this.t20_1 + ', cardSaveError=' + this.u20_1 + ', genericErrorPrefix=' + this.v20_1 + ')';
  };
  protoOf(AddCardLabels).hashCode = function () {
    var result = getStringHashCode(this.s20_1);
    result = imul(result, 31) + getStringHashCode(this.t20_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.u20_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.v20_1) | 0;
    return result;
  };
  protoOf(AddCardLabels).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof AddCardLabels))
      return false;
    if (!(this.s20_1 === other.s20_1))
      return false;
    if (!(this.t20_1 === other.t20_1))
      return false;
    if (!(this.u20_1 === other.u20_1))
      return false;
    if (!(this.v20_1 === other.v20_1))
      return false;
    return true;
  };
  function mountStripeCardElement($this, publishableKey, clientSecret, containerId, saveButtonId) {
    if (!stripeJsLoaded()) {
      $this.a21_1($this.z20_1.t20_1);
      return Unit_instance;
    }
    var stripe = Stripe(publishableKey);
    var elementsOptions = {};
    elementsOptions.clientSecret = clientSecret;
    var elements = stripe.elements(elementsOptions);
    $this.c21_1 = elements;
    var paymentElement = elements.create('payment');
    paymentElement.mount('#' + containerId);
    var tmp = document.getElementById(saveButtonId);
    var tmp_0 = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    tmp_0.addEventListener('click', AddCardFlow$mountStripeCardElement$lambda($this, elements, stripe));
  }
  function mountPayPalButton($this, clientId, setupTokenId, containerId) {
    loadPayPalSdk(clientId, AddCardFlow$mountPayPalButton$lambda(containerId, setupTokenId, $this));
  }
  function pollForNewPaymentMethod($this, $completion) {
    var tmp = new $pollForNewPaymentMethodCOROUTINE$($this, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  }
  function AddCardFlow$mountStripeCardElement$lambda$slambda(this$0, $elements, $stripe, resultContinuation) {
    this.c22_1 = this$0;
    this.d22_1 = $elements;
    this.e22_1 = $stripe;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(AddCardFlow$mountStripeCardElement$lambda$slambda).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(AddCardFlow$mountStripeCardElement$lambda$slambda).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(AddCardFlow$mountStripeCardElement$lambda$slambda).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 6;
            this.c22_1.a21_1('');
            this.u7_1 = 4;
            var confirmOptions = {};
            confirmOptions.elements = this.d22_1;
            var confirmParams = {};
            confirmParams.return_url = window.location.href;
            confirmOptions.confirmParams = confirmParams;
            confirmOptions.redirect = 'if_required';
            this.t7_1 = 1;
            suspendResult = await_0(this.e22_1.confirmSetup(confirmOptions), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var result = suspendResult;
            var error = result.error;
            if (error != null) {
              var tmp_0 = error.message;
              var tmp0_elvis_lhs = (!(tmp_0 == null) ? typeof tmp_0 === 'string' : false) ? tmp_0 : null;
              this.c22_1.a21_1(tmp0_elvis_lhs == null ? this.c22_1.z20_1.u20_1 : tmp0_elvis_lhs);
              this.t7_1 = 3;
              continue $sm;
            } else {
              this.t7_1 = 2;
              suspendResult = pollForNewPaymentMethod(this.c22_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 2:
            this.t7_1 = 3;
            continue $sm;
          case 3:
            this.u7_1 = 6;
            this.t7_1 = 5;
            continue $sm;
          case 4:
            this.u7_1 = 6;
            var tmp_1 = this.w7_1;
            if (tmp_1 instanceof Error) {
              var e = this.w7_1;
              this.c22_1.a21_1(this.c22_1.z20_1.v20_1 + e.message);
              this.t7_1 = 5;
              continue $sm;
            } else {
              throw this.w7_1;
            }

          case 5:
            this.u7_1 = 6;
            return Unit_instance;
          case 6:
            throw this.w7_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.u7_1 === 6) {
          throw e_0;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(AddCardFlow$mountStripeCardElement$lambda$slambda).h22 = function ($this$launch, completion) {
    var i = new AddCardFlow$mountStripeCardElement$lambda$slambda(this.c22_1, this.d22_1, this.e22_1, completion);
    i.f22_1 = $this$launch;
    return i;
  };
  function AddCardFlow$mountStripeCardElement$lambda$slambda_0(this$0, $elements, $stripe, resultContinuation) {
    var i = new AddCardFlow$mountStripeCardElement$lambda$slambda(this$0, $elements, $stripe, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  function AddCardFlow$mountStripeCardElement$lambda(this$0, $elements, $stripe) {
    return function (it) {
      var tmp = MainScope();
      launch(tmp, VOID, VOID, AddCardFlow$mountStripeCardElement$lambda$slambda_0(this$0, $elements, $stripe, null));
      return Unit_instance;
    };
  }
  function AddCardFlow$mountPayPalButton$lambda$lambda($setupTokenId) {
    return function () {
      return Promise.resolve($setupTokenId);
    };
  }
  function AddCardFlow$mountPayPalButton$lambda$lambda$slambda(this$0, resultContinuation) {
    this.q22_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(AddCardFlow$mountPayPalButton$lambda$lambda$slambda).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(AddCardFlow$mountPayPalButton$lambda$lambda$slambda).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(AddCardFlow$mountPayPalButton$lambda$lambda$slambda).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 2;
            this.t7_1 = 1;
            suspendResult = pollForNewPaymentMethod(this.q22_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.w7_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.u7_1 === 2) {
          throw e;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e;
        }
      }
     while (true);
  };
  protoOf(AddCardFlow$mountPayPalButton$lambda$lambda$slambda).h22 = function ($this$launch, completion) {
    var i = new AddCardFlow$mountPayPalButton$lambda$lambda$slambda(this.q22_1, completion);
    i.r22_1 = $this$launch;
    return i;
  };
  function AddCardFlow$mountPayPalButton$lambda$lambda$slambda_0(this$0, resultContinuation) {
    var i = new AddCardFlow$mountPayPalButton$lambda$lambda$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  function AddCardFlow$mountPayPalButton$lambda$lambda_0(this$0) {
    return function (_unused_var__etf5q3) {
      var tmp = MainScope();
      launch(tmp, VOID, VOID, AddCardFlow$mountPayPalButton$lambda$lambda$slambda_0(this$0, null));
      return Unit_instance;
    };
  }
  function AddCardFlow$mountPayPalButton$lambda($containerId, $setupTokenId, this$0) {
    return function () {
      var tmp;
      if (!payPalSdkLoaded()) {
        return Unit_instance;
      }
      var options = {};
      options.createVaultSetupToken = AddCardFlow$mountPayPalButton$lambda$lambda($setupTokenId);
      options.onApprove = AddCardFlow$mountPayPalButton$lambda$lambda_0(this$0);
      (new paypal.Buttons(options)).render('#' + $containerId);
      return Unit_instance;
    };
  }
  function $startCOROUTINE$(_this__u8e3s4, stripeCardElementContainerId, saveButtonId, payPalButtonContainerId, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.a23_1 = _this__u8e3s4;
    this.b23_1 = stripeCardElementContainerId;
    this.c23_1 = saveButtonId;
    this.d23_1 = payPalButtonContainerId;
  }
  protoOf($startCOROUTINE$).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 5;
            this.a23_1.a21_1('');
            this.u7_1 = 3;
            var tmp0 = this.a23_1.w20_1;
            var path = this.a23_1.y20_1;
            this.g23_1 = get_paymentsKitJson();
            this.t7_1 = 1;
            suspendResult = tmp0.h23(path, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp2 = suspendResult;
            var tmp_0 = this;
            var this_0 = this.g23_1;
            var this_1 = this_0.um();
            var this_2 = serializer(this_1, createKType(getKClass(PaymentsPublicConfigDto), arrayOf([]), false));
            tmp_0.e23_1 = this_0.i13(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), tmp2);
            var tmp0_0 = this.a23_1.w20_1;
            var path_0 = this.a23_1.x20_1 + '/setup-intents';
            this.f23_1 = get_paymentsKitJson();
            this.t7_1 = 2;
            suspendResult = tmp0_0.i23(path_0, null, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var tmp2_0 = suspendResult;
            var this_3 = this.f23_1;
            var this_4 = this_3.um();
            var this_5 = serializer(this_4, createKType(getKClass(SetupIntentsResponseDto), arrayOf([]), false));
            var result = this_3.i13(isInterface(this_5, KSerializer) ? this_5 : THROW_CCE(), tmp2_0);
            var tmp0_1 = result.c1f_1;
            var tmp$ret$0 = Unit_instance;
            l$ret$1: do {
              var _iterator__ex2g4s = tmp0_1.t();
              while (_iterator__ex2g4s.u()) {
                var element = _iterator__ex2g4s.v();
                if (element.f1f_1 === 'STRIPE') {
                  tmp$ret$0 = element;
                  break l$ret$1;
                }
              }
              tmp$ret$0 = null;
            }
             while (false);
            var stripeIntent = tmp$ret$0;
            var tmp0_2 = result.c1f_1;
            var tmp$ret$2 = Unit_instance;
            l$ret$3: do {
              var _iterator__ex2g4s_0 = tmp0_2.t();
              while (_iterator__ex2g4s_0.u()) {
                var element_0 = _iterator__ex2g4s_0.v();
                if (element_0.f1f_1 === 'PAYPAL') {
                  tmp$ret$2 = element_0;
                  break l$ret$3;
                }
              }
              tmp$ret$2 = null;
            }
             while (false);
            var paypalIntent = tmp$ret$2;
            var stripePublishableKey = this.e23_1.x1e_1;
            var paypalClientId = this.e23_1.y1e_1;
            if (!(stripeIntent == null) && !(stripePublishableKey == null)) {
              mountStripeCardElement(this.a23_1, stripePublishableKey, stripeIntent.g1f_1, this.b23_1, this.c23_1);
            }

            if (!(paypalIntent == null) && !(paypalClientId == null)) {
              mountPayPalButton(this.a23_1, paypalClientId, paypalIntent.g1f_1, this.d23_1);
            }

            if (stripeIntent == null && paypalIntent == null) {
              this.a23_1.a21_1(this.a23_1.z20_1.s20_1);
            }

            this.u7_1 = 5;
            this.t7_1 = 4;
            continue $sm;
          case 3:
            this.u7_1 = 5;
            var tmp_1 = this.w7_1;
            if (tmp_1 instanceof Error) {
              var e = this.w7_1;
              this.a23_1.a21_1(this.a23_1.z20_1.v20_1 + e.message);
              this.t7_1 = 4;
              continue $sm;
            } else {
              throw this.w7_1;
            }

          case 4:
            this.u7_1 = 5;
            return Unit_instance;
          case 5:
            throw this.w7_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.u7_1 === 5) {
          throw e_0;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_0;
        }
      }
     while (true);
  };
  function $pollForNewPaymentMethodCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.l21_1 = _this__u8e3s4;
  }
  protoOf($pollForNewPaymentMethodCOROUTINE$).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 10;
            var this_0 = this.l21_1;
            this.u7_1 = 2;
            this.s21_1 = Companion_instance;
            var tmp0 = this_0.w20_1;
            var path = this_0.x20_1;
            this.t21_1 = get_paymentsKitJson();
            this.t7_1 = 1;
            suspendResult = tmp0.h23(path, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp2 = suspendResult;
            var this_1 = this.t21_1;
            var this_2 = this_1.um();
            var this_3 = serializer(this_2, createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(PaymentMethodDto), arrayOf([]), false))]), false));
            var tmp2_0 = this_1.i13(isInterface(this_3, KSerializer) ? this_3 : THROW_CCE(), tmp2);
            var tmp_0 = this;
            this.s21_1;
            tmp_0.r21_1 = _Result___init__impl__xyqfz8(tmp2_0);
            this.u7_1 = 10;
            this.t7_1 = 3;
            continue $sm;
          case 2:
            this.u7_1 = 10;
            var tmp_1 = this.w7_1;
            if (tmp_1 instanceof Error) {
              var e = this.w7_1;
              var tmp_2 = this;
              tmp_2.r21_1 = _Result___init__impl__xyqfz8(createFailure(e));
              this.t7_1 = 3;
              continue $sm;
            } else {
              throw this.w7_1;
            }

          case 3:
            this.u7_1 = 10;
            var tmp0_0 = this.r21_1;
            var tmp2_1 = emptyList();
            var tmp_3 = this;
            var tmp$ret$0;
            l$ret$1: do {
              if (_Result___get_isFailure__impl__jpiriv(tmp0_0)) {
                tmp$ret$0 = tmp2_1;
                break l$ret$1;
              }
              tmp$ret$0 = _Result___get_value__impl__bjfvqg(tmp0_0);
            }
             while (false);
            tmp_3.m21_1 = tmp$ret$0;
            this.q21_1 = until(0, 10).t();
            this.t7_1 = 4;
            continue $sm;
          case 4:
            if (!this.q21_1.u()) {
              this.t7_1 = 9;
              continue $sm;
            }

            var index = this.q21_1.v();
            this.t7_1 = 5;
            suspendResult = delay(new Long(500, 0), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            var this_4 = this.l21_1;
            this.u7_1 = 7;
            this.o21_1 = Companion_instance;
            var tmp0_1 = this_4.w20_1;
            var path_0 = this_4.x20_1;
            this.p21_1 = get_paymentsKitJson();
            this.t7_1 = 6;
            suspendResult = tmp0_1.h23(path_0, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 6:
            var tmp2_2 = suspendResult;
            var this_5 = this.p21_1;
            var this_6 = this_5.um();
            var this_7 = serializer(this_6, createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(PaymentMethodDto), arrayOf([]), false))]), false));
            var tmp2_3 = this_5.i13(isInterface(this_7, KSerializer) ? this_7 : THROW_CCE(), tmp2_2);
            var tmp_4 = this;
            this.o21_1;
            tmp_4.n21_1 = _Result___init__impl__xyqfz8(tmp2_3);
            this.u7_1 = 10;
            this.t7_1 = 8;
            continue $sm;
          case 7:
            this.u7_1 = 10;
            var tmp_5 = this.w7_1;
            if (tmp_5 instanceof Error) {
              var e_0 = this.w7_1;
              var tmp_6 = this;
              tmp_6.n21_1 = _Result___init__impl__xyqfz8(createFailure(e_0));
              this.t7_1 = 8;
              continue $sm;
            } else {
              throw this.w7_1;
            }

          case 8:
            this.u7_1 = 10;
            var tmp0_2 = this.n21_1;
            var tmp2_4 = emptyList();
            var tmp$ret$2;
            l$ret$3: do {
              if (_Result___get_isFailure__impl__jpiriv(tmp0_2)) {
                tmp$ret$2 = tmp2_4;
                break l$ret$3;
              }
              tmp$ret$2 = _Result___get_value__impl__bjfvqg(tmp0_2);
            }
             while (false);
            var after = tmp$ret$2;
            var tmp_7;
            if (after.z() > this.m21_1.z()) {
              tmp_7 = true;
            } else {
              var sum = 0;
              var _iterator__ex2g4s = after.t();
              while (_iterator__ex2g4s.u()) {
                var element = _iterator__ex2g4s.v();
                var tmp_8 = sum;
                sum = tmp_8 + element.u1e_1.z() | 0;
              }
              var tmp_9 = sum;
              var sum_0 = 0;
              var _iterator__ex2g4s_0 = this.m21_1.t();
              while (_iterator__ex2g4s_0.u()) {
                var element_0 = _iterator__ex2g4s_0.v();
                var tmp_10 = sum_0;
                sum_0 = tmp_10 + element_0.u1e_1.z() | 0;
              }
              tmp_7 = tmp_9 > sum_0;
            }

            if (tmp_7) {
              this.l21_1.b21_1();
              return Unit_instance;
            }

            this.t7_1 = 4;
            continue $sm;
          case 9:
            this.l21_1.b21_1();
            return Unit_instance;
          case 10:
            throw this.w7_1;
        }
      } catch ($p) {
        var e_1 = $p;
        if (this.u7_1 === 10) {
          throw e_1;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_1;
        }
      }
     while (true);
  };
  function AddCardFlow(httpClient, basePath, publicConfigPath, labels, onStatus, onSaved) {
    this.w20_1 = httpClient;
    this.x20_1 = basePath;
    this.y20_1 = publicConfigPath;
    this.z20_1 = labels;
    this.a21_1 = onStatus;
    this.b21_1 = onSaved;
    this.c21_1 = null;
  }
  protoOf(AddCardFlow).j23 = function (stripeCardElementContainerId, saveButtonId, payPalButtonContainerId, $completion) {
    var tmp = new $startCOROUTINE$(this, stripeCardElementContainerId, saveButtonId, payPalButtonContainerId, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  var loadingClientId;
  function loadPayPalSdk(clientId, onLoad) {
    if (payPalSdkLoaded()) {
      onLoad();
      return Unit_instance;
    }
    if (loadingClientId === clientId) {
      var tmp = document.getElementById('paymentskit-paypal-sdk-script');
      var tmp0_safe_receiver = tmp instanceof HTMLScriptElement ? tmp : null;
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.addEventListener('load', loadPayPalSdk$lambda(onLoad));
      }
      return Unit_instance;
    }
    loadingClientId = clientId;
    var tmp_0 = document.createElement('script');
    var script = tmp_0 instanceof HTMLScriptElement ? tmp_0 : THROW_CCE();
    script.id = 'paymentskit-paypal-sdk-script';
    script.src = 'https://www.paypal.com/sdk/js?client-id=' + clientId + '&components=buttons&vault=true&intent=capture';
    script.addEventListener('load', loadPayPalSdk$lambda_0(onLoad));
    var tmp1_safe_receiver = document.head;
    if (tmp1_safe_receiver == null)
      null;
    else
      tmp1_safe_receiver.appendChild(script);
  }
  function payPalSdkLoaded() {
    // Inline function 'kotlin.js.asDynamic' call
    return window.paypal != undefined;
  }
  function loadPayPalSdk$lambda($onLoad) {
    return function (it) {
      $onLoad();
      return Unit_instance;
    };
  }
  function loadPayPalSdk$lambda_0($onLoad) {
    return function (it) {
      $onLoad();
      return Unit_instance;
    };
  }
  function PaymentMethodsClassNames(card, cardMeta, badge, actions, buttonPrimary, buttonDanger) {
    card = card === VOID ? 'paymentskit-card' : card;
    cardMeta = cardMeta === VOID ? 'paymentskit-card-meta' : cardMeta;
    badge = badge === VOID ? 'paymentskit-badge' : badge;
    actions = actions === VOID ? 'paymentskit-actions' : actions;
    buttonPrimary = buttonPrimary === VOID ? 'paymentskit-button paymentskit-button-primary' : buttonPrimary;
    buttonDanger = buttonDanger === VOID ? 'paymentskit-button paymentskit-button-danger' : buttonDanger;
    this.k23_1 = card;
    this.l23_1 = cardMeta;
    this.m23_1 = badge;
    this.n23_1 = actions;
    this.o23_1 = buttonPrimary;
    this.p23_1 = buttonDanger;
  }
  protoOf(PaymentMethodsClassNames).toString = function () {
    return 'PaymentMethodsClassNames(card=' + this.k23_1 + ', cardMeta=' + this.l23_1 + ', badge=' + this.m23_1 + ', actions=' + this.n23_1 + ', buttonPrimary=' + this.o23_1 + ', buttonDanger=' + this.p23_1 + ')';
  };
  protoOf(PaymentMethodsClassNames).hashCode = function () {
    var result = getStringHashCode(this.k23_1);
    result = imul(result, 31) + getStringHashCode(this.l23_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.m23_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.n23_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.o23_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.p23_1) | 0;
    return result;
  };
  protoOf(PaymentMethodsClassNames).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PaymentMethodsClassNames))
      return false;
    if (!(this.k23_1 === other.k23_1))
      return false;
    if (!(this.l23_1 === other.l23_1))
      return false;
    if (!(this.m23_1 === other.m23_1))
      return false;
    if (!(this.n23_1 === other.n23_1))
      return false;
    if (!(this.o23_1 === other.o23_1))
      return false;
    if (!(this.p23_1 === other.p23_1))
      return false;
    return true;
  };
  function PaymentMethodsLabels(noMethodsYet, expiresPrefix, primaryLabel, setPrimaryButton, removeButton, providersPrefix) {
    this.q23_1 = noMethodsYet;
    this.r23_1 = expiresPrefix;
    this.s23_1 = primaryLabel;
    this.t23_1 = setPrimaryButton;
    this.u23_1 = removeButton;
    this.v23_1 = providersPrefix;
  }
  protoOf(PaymentMethodsLabels).toString = function () {
    return 'PaymentMethodsLabels(noMethodsYet=' + this.q23_1 + ', expiresPrefix=' + this.r23_1 + ', primaryLabel=' + this.s23_1 + ', setPrimaryButton=' + this.t23_1 + ', removeButton=' + this.u23_1 + ', providersPrefix=' + this.v23_1 + ')';
  };
  protoOf(PaymentMethodsLabels).hashCode = function () {
    var result = getStringHashCode(this.q23_1);
    result = imul(result, 31) + getStringHashCode(this.r23_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.s23_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.t23_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.u23_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.v23_1) | 0;
    return result;
  };
  protoOf(PaymentMethodsLabels).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PaymentMethodsLabels))
      return false;
    if (!(this.q23_1 === other.q23_1))
      return false;
    if (!(this.r23_1 === other.r23_1))
      return false;
    if (!(this.s23_1 === other.s23_1))
      return false;
    if (!(this.t23_1 === other.t23_1))
      return false;
    if (!(this.u23_1 === other.u23_1))
      return false;
    if (!(this.v23_1 === other.v23_1))
      return false;
    return true;
  };
  function renderPaymentMethodsList(container, methods, labels, onSetDefault, onRemove, classNames) {
    classNames = classNames === VOID ? new PaymentMethodsClassNames() : classNames;
    container.innerHTML = '';
    if (methods.r()) {
      append(container, renderPaymentMethodsList$lambda(labels));
      return Unit_instance;
    }
    append(container, renderPaymentMethodsList$lambda_0(methods, classNames, labels, onSetDefault, onRemove));
  }
  function renderPaymentMethodsList$lambda($labels) {
    return function ($this$append) {
      // Inline function 'kotlinx.html.p' call
      // Inline function 'kotlinx.html.visitAndFinalize' call
      // Inline function 'kotlinx.html.visitTagAndFinalize' call
      var this_0 = new P(attributesMapOf('class', null), $this$append);
      if (!(this_0.j1f() === $this$append)) {
        throw IllegalArgumentException_init_$Create$('Wrong exception');
      }
      // Inline function 'kotlinx.html.visitTag' call
      this_0.j1f().a1h(this_0);
      this_0.n1f($labels.q23_1);
      this_0.j1f().b1h(this_0);
      $this$append.d1h();
      return Unit_instance;
    };
  }
  function renderPaymentMethodsList$lambda$lambda($onSetDefault, $method) {
    return function (it) {
      $onSetDefault($method);
      return Unit_instance;
    };
  }
  function renderPaymentMethodsList$lambda$lambda_0($onRemove, $method) {
    return function (it) {
      $onRemove($method);
      return Unit_instance;
    };
  }
  function renderPaymentMethodsList$lambda_0($methods, $classNames, $labels, $onSetDefault, $onRemove) {
    return function ($this$append) {
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s = $methods.t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        // Inline function 'kotlinx.html.div' call
        var classes = $classNames.k23_1;
        // Inline function 'kotlinx.html.visitAndFinalize' call
        // Inline function 'kotlinx.html.visitTagAndFinalize' call
        var this_0 = new DIV(attributesMapOf('class', classes), $this$append);
        if (!(this_0.j1f() === $this$append)) {
          throw IllegalArgumentException_init_$Create$('Wrong exception');
        }
        // Inline function 'kotlinx.html.visitTag' call
        this_0.j1f().a1h(this_0);
        // Inline function 'kotlinx.html.p' call
        // Inline function 'kotlinx.html.visit' call
        // Inline function 'kotlinx.html.visitTag' call
        var this_1 = new P(attributesMapOf('class', null), this_0.j1f());
        this_1.j1f().a1h(this_1);
        // Inline function 'kotlin.text.uppercase' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$13 = element.p1e_1.toUpperCase();
        this_1.n1f(tmp$ret$13 + ' \u2022\u2022\u2022\u2022 ' + element.q1e_1);
        this_1.j1f().b1h(this_1);
        // Inline function 'kotlinx.html.p' call
        // Inline function 'kotlinx.html.visit' call
        // Inline function 'kotlinx.html.visitTag' call
        var this_2 = new P(attributesMapOf('class', null), this_0.j1f());
        this_2.j1f().a1h(this_2);
        this_2.n1f($labels.r23_1 + element.r1e_1 + '/' + element.s1e_1);
        this_2.j1f().b1h(this_2);
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!element.u1e_1.r()) {
          // Inline function 'kotlinx.html.p' call
          var classes_0 = $classNames.l23_1;
          // Inline function 'kotlinx.html.visit' call
          // Inline function 'kotlinx.html.visitTag' call
          var this_3 = new P(attributesMapOf('class', classes_0), this_0.j1f());
          this_3.j1f().a1h(this_3);
          this_3.n1f($labels.v23_1 + joinToString(element.u1e_1, ', '));
          this_3.j1f().b1h(this_3);
        }
        if (element.t1e_1) {
          // Inline function 'kotlinx.html.span' call
          var classes_1 = $classNames.m23_1;
          // Inline function 'kotlinx.html.visit' call
          // Inline function 'kotlinx.html.visitTag' call
          var this_4 = new SPAN(attributesMapOf('class', classes_1), this_0.j1f());
          this_4.j1f().a1h(this_4);
          this_4.n1f($labels.s23_1);
          this_4.j1f().b1h(this_4);
        }
        // Inline function 'kotlinx.html.div' call
        var classes_2 = $classNames.n23_1;
        // Inline function 'kotlinx.html.visit' call
        // Inline function 'kotlinx.html.visitTag' call
        var this_5 = new DIV(attributesMapOf('class', classes_2), this_0.j1f());
        this_5.j1f().a1h(this_5);
        if (!element.t1e_1) {
          // Inline function 'kotlinx.html.button' call
          var classes_3 = $classNames.o23_1;
          var tmp = null == null ? null : enumEncode(null);
          var tmp_0 = null == null ? null : enumEncode(null);
          // Inline function 'kotlinx.html.visit' call
          // Inline function 'kotlinx.html.visitTag' call
          var this_6 = new BUTTON(attributesMapOf_0(['formenctype', tmp, 'formmethod', tmp_0, 'name', null, 'type', null == null ? null : enumEncode(null), 'class', classes_3]), this_5.j1f());
          this_6.j1f().a1h(this_6);
          this_6.z1j(ButtonType_button_getInstance());
          set_onClickFunction(this_6, renderPaymentMethodsList$lambda$lambda($onSetDefault, element));
          this_6.n1f($labels.t23_1);
          this_6.j1f().b1h(this_6);
        }
        // Inline function 'kotlinx.html.button' call
        var classes_4 = $classNames.p23_1;
        var tmp_1 = null == null ? null : enumEncode(null);
        var tmp_2 = null == null ? null : enumEncode(null);
        // Inline function 'kotlinx.html.visit' call
        // Inline function 'kotlinx.html.visitTag' call
        var this_7 = new BUTTON(attributesMapOf_0(['formenctype', tmp_1, 'formmethod', tmp_2, 'name', null, 'type', null == null ? null : enumEncode(null), 'class', classes_4]), this_5.j1f());
        this_7.j1f().a1h(this_7);
        this_7.z1j(ButtonType_button_getInstance());
        set_onClickFunction(this_7, renderPaymentMethodsList$lambda$lambda_0($onRemove, element));
        this_7.n1f($labels.u23_1);
        this_7.j1f().b1h(this_7);
        this_5.j1f().b1h(this_5);
        this_0.j1f().b1h(this_0);
        $this$append.d1h();
      }
      return Unit_instance;
    };
  }
  var PAYMENTSKIT_DEFAULT_CSS;
  function stripeJsLoaded() {
    // Inline function 'kotlin.js.asDynamic' call
    return window.Stripe != undefined;
  }
  //region block: init
  loadingClientId = null;
  PAYMENTSKIT_DEFAULT_CSS = ':root {\n  --paymentskit-color-primary: #2563eb;\n  --paymentskit-color-danger: #dc2626;\n  --paymentskit-color-text: #111827;\n  --paymentskit-color-muted: #6b7280;\n  --paymentskit-color-surface: #ffffff;\n  --paymentskit-color-border: #e5e7eb;\n  --paymentskit-radius: clamp(0.375rem, 0.6vw, 0.75rem);\n  --paymentskit-spacing-unit: 1vw;\n}\n\n.paymentskit-card {\n  background: var(--paymentskit-color-surface);\n  border: 1px solid var(--paymentskit-color-border);\n  border-radius: var(--paymentskit-radius);\n  padding: clamp(0.75rem, calc(2 * var(--paymentskit-spacing-unit)), 1.5rem);\n  margin-block-end: clamp(0.5rem, calc(1.5 * var(--paymentskit-spacing-unit)), 1rem);\n  color: var(--paymentskit-color-text);\n  font-size: clamp(0.875rem, 1.4vw, 1rem);\n}\n\n.paymentskit-card-meta {\n  color: var(--paymentskit-color-muted);\n  font-size: clamp(0.75rem, 1.1vw, 0.875rem);\n}\n\n.paymentskit-badge {\n  display: inline-block;\n  background: var(--paymentskit-color-primary);\n  color: var(--paymentskit-color-surface);\n  border-radius: var(--paymentskit-radius);\n  padding: clamp(0.125rem, 0.4vw, 0.25rem) clamp(0.375rem, 0.8vw, 0.625rem);\n  font-size: clamp(0.6875rem, 1vw, 0.75rem);\n}\n\n.paymentskit-actions {\n  display: flex;\n  gap: clamp(0.5rem, calc(1.5 * var(--paymentskit-spacing-unit)), 1rem);\n  margin-block-start: clamp(0.5rem, calc(1.5 * var(--paymentskit-spacing-unit)), 1rem);\n}\n\n.paymentskit-button {\n  border: none;\n  border-radius: var(--paymentskit-radius);\n  padding: clamp(0.375rem, calc(1.2 * var(--paymentskit-spacing-unit)), 0.625rem)\n           clamp(0.75rem, calc(2.4 * var(--paymentskit-spacing-unit)), 1.25rem);\n  font-size: clamp(0.8125rem, 1.2vw, 0.9375rem);\n  cursor: pointer;\n  color: var(--paymentskit-color-surface);\n}\n\n.paymentskit-button-primary {\n  background: var(--paymentskit-color-primary);\n}\n\n.paymentskit-button-danger {\n  background: var(--paymentskit-color-danger);\n}';
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = AddCardFlow;
  _.$_$.b = AddCardLabels;
  _.$_$.c = PaymentMethodsClassNames;
  _.$_$.d = PaymentMethodsLabels;
  _.$_$.e = renderPaymentMethodsList;
  //endregion
  return _;
}));

